// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D_Ov","content":"styles_content__1VAFQ","row":"styles_row__fpYQ_","footer":"styles_footer__2lhpN","phraseLength":"styles_phraseLength__2a-EL"};